export default {"src":"/_next/static/media/Mexico_Import_Icon.e943ce07.svg","height":34,"width":31};